// src/components/SplashScreen.tsx
import React, { useEffect, useState } from "react";

interface SplashScreenProps {
  onFinish?: () => void;
  minimumLoadTimeMs?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({
  onFinish,
  minimumLoadTimeMs = 1000,
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = Math.min(
        (elapsedTime / minimumLoadTimeMs) * 100,
        100
      );

      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(interval);
        onFinish?.();
      }
    }, 50);

    return () => clearInterval(interval);
  }, [minimumLoadTimeMs, onFinish]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-pink-450">
      {/* Logo container */}
      <div className="w-32 h-32 mb-8 relative">
        <img
          src="/favicon.ico"
          alt="Sistema de Caja"
          className="w-full h-full object-contain"
        />
      </div>

      {/* App name */}
      <h1 className="text-2xl font-bold text-white mb-8">Sistema de Caja</h1>

      {/* Progress bar */}
      <div className="w-64 bg-pink-900/50 rounded-full h-2 overflow-hidden">
        <div
          className="h-full bg-white transition-all duration-300 ease-out rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Loading text */}
      <p className="text-pink-100 mt-4 text-sm">
        {progress < 100 ? "Cargando..." : "Iniciando aplicación"}
      </p>
    </div>
  );
};

export default SplashScreen;
